import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from '@bndes/bndes-ux4/bn-seguranca';
import { EscolhaModalidadeGuard } from 'src/app/interceptors/escolha-modalidade.guard';
import { PesquisaComponent } from './pesquisa/pesquisa.component';
import { SolicitacaoComponent } from './solicitacao/solicitacao.component';

const routes: Routes = [
  {
    path: 'renuncia-limite-adicional/pesquisa',
    component: PesquisaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false },
  },
  {
    path: 'renuncia-limite-adicional/solicitacao/:ideTranche/:ideAgente',
    component: SolicitacaoComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RenunciaLimiteAdicionalRoutingModule { }